import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { store } from '@/store'
import { getUserByUid } from '@/firebase_files/user_functions'
import { role } from '@/firebase_files/login'

import ClinicView from '../clinic/ClinicView.vue';
import AppointmentView from '../appointment/AppointmentView.vue'
import RegistrationView from '../registration/RegistrationView.vue'
import EditAccountView from '../edit_account/EditAccountView.vue';
import ViewClaims from '../views/ViewClaims.vue'
import PatientDisplayView from '../patient/PatientDisplayView.vue';
import SecretaryDashboardView from '@/secretary_dashboard/SecretaryDashboardView.vue';
import WaitingScreen from '@/views/WaitingView.vue';
import LoginViewVue from '@/login/LoginView.vue';

import HomePageView from '../home/HomeView';


const routes = [
  {
    path:'/login',
    name:'login',
    component:LoginViewVue
  },
  {
    path:'/loading',
    name:'loading',
    component:WaitingScreen,
  },
  {
    path: '/',
    name: 'home',
    component: ClinicView,
    meta: { rolesAllowed: ['physician'] }
  },
  {
    path: '/appointment/:id?',
    name: 'appointment',
    component: AppointmentView,
    meta: { rolesAllowed: ['physician'] }
  },
  {
    path: '/registration',
    name: 'registration',
    component: RegistrationView,
    meta: { rolesAllowed: ['physician', 'secretary'] }
  },
  {
    path: '/view-claims',
    name: 'view-claims',
    component: ViewClaims,
    meta: { rolesAllowed: ['physician'] }
  },
  {
    path: '/patient',
    name: 'patient',
    component: PatientDisplayView,
    meta: { rolesAllowed: ['physician'] }
  },
  {
    path: '/edit-account/:newAct?/:role?',
    name: 'edit-account',
    component: EditAccountView,
    meta: {rolesAllowed: ['physician', 'secretary']}
  },
  {
    path:'/dashboard/',
    name: 'dashboard',
    component: SecretaryDashboardView,
    meta: {rolesAllowed: ['physician', 'secretary']}
  },
  {
  path: '/home/',
  name: 'homePage', 
component: HomePageView,
  meta: {rolesAllowed: ['physician', 'secretary']}
}
]
const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach(async (to, from) => {
  const s = store;
  if (to.name=='login'){
    // since we redirect to login, this is recursive base case
    return true; 
  }
  else if (!store.user){
    return ({
      path: '/login/',
    })
  }

  if (!to.meta.rolesAllowed) return true;
  if(store.newUser && to.name=='edit-account') return true;
  if (store.newUser){
    return ({
      path: '/edit-account/',
      params:{ newAct:'true'}
    })
  }

  const role = await store.userRole;
  const validRoleForPage = to.meta.rolesAllowed.includes(role);
  // if by some curse of the almighty roles still aren't working, back to login
  if (!role){ 
    return ({
      path: '/login/'
    })
  }
  if (role=='secretary' && !validRoleForPage){
    return({
      path:'/dashboard/'
    })
  }
  else if (role == 'physician' && !validRoleForPage){
    return ({
      path:'/', // bring to clinic page
    })
  }
  else if (!validRoleForPage){
    alert('role not defined in router')
    return false;
  }
  return true;
})

export default router